<ng-container *transloco="let t; prefix: 'uiKit.unsavedChanges'">
  <div class="modal-header">
    <h4 class="modal-title">{{ t('title') }}</h4>
    <ui-button
      [icon]="'cross-square'"
      [iconClass]="'fs-2 text-info'"
      [severity]="'light'"
      [size]="'auto'"
      (click)="stay()"
    ></ui-button>
  </div>
  <div class="modal-body">
    <p class="fw-bold m-0">{{ t('description') }}</p>
  </div>
  <div class="modal-footer">
    <ui-button
      [severity]="'secondary'"
      [buttonText]="t('stay')"
      (click)="stay()"
    ></ui-button>
    <ui-button
      [severity]="'danger'"
      [buttonText]="t('leave')"
      (click)="leave()"
    ></ui-button>
  </div>
</ng-container>
